import React from 'react';
import { useNavigate } from 'react-router-dom';
import saleBannerImg from '../../assets/sale-banner.png';
import './SaleMidBanner.css';

export default function SaleMidBanner() {
  const navigate = useNavigate();
  return (
    <div
      className="sale-mid-banner"
      onClick={() => navigate('/marketplace/banner/sale')}
    >
      <img src={saleBannerImg} alt="Sale Banner" />
    </div>
  );
}
